import { render, staticRenderFns } from "./AppHeaderDropdown.vue?vue&type=template&id=f79f07d2&scoped=true"
import script from "./AppHeaderDropdown.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdown.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderDropdown.vue?vue&type=style&index=0&id=f79f07d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79f07d2",
  null
  
)

export default component.exports